
import { Options, Vue } from "vue-class-component";
import Modal from "@/components/Modal.vue";

@Options({
  components: {
    Modal,
  },
  props: {},
})
export default class NewTitleModal extends Vue {
  show = false;
  content = "";
  open(): void {
    this.show = true;
  }

  async submitTitle(): Promise<void> {
    const ens = this.$store.state.ensName?.replace(".eth", "");
    if (this.content && ens) {
      this.show = false;
      this.$store.commit("setMetaLoading", true);
      try {
        const res = await this.$store.state.solApp?.addTitle(
          ens,
          this.content,
          {
            from: this.$store.state.account,
            value: (0.001*(10**18)).toString()
          }
        );
        console.warn(res);
        this.content = "";
        window.location.reload();
      } catch (err) {
        this.show = true;
        console.error(err);
      }
      this.$store.commit("setMetaLoading", false);
    }
  }
}
